module.exports = __webpack_public_path__ + "img/cover2.6f44196c.jpg";